export const LOCALE = {
  loadingData: "Loading data...",
  errorOccurred: "An Error Occurred",
  error: "Error",
  upload: "Upload Source File",
  start: "Start",
  uploadedFiles: "Recent File Uploads",
  files: "Files"
};
